import { Link } from "react-router-dom";

const STR = {
  fr: {
    mentions: "Mentions légales",
    cgu: "CGU",
    cgv: "CGV",
    privacy: "Confidentialité",
    cookies: "Cookies",
    withdrawal: "Rétractation",
    affiliate: "Devenir affilié",
    contact: "Contact légal",
    copyright: "© Harf — Apprendre l'arabe progressivement",
  },
  en: {
    mentions: "Legal Notice",
    cgu: "Terms of Use",
    cgv: "Terms and Conditions",
    privacy: "Privacy",
    cookies: "Cookies",
    withdrawal: "Right of Withdrawal",
    affiliate: "Become an Affiliate",
    contact: "Legal Contact",
    copyright: "© Harf — Learn Arabic, step by step",
  },
};

// Les pages légales elles-mêmes (Legal.jsx) et le programme affilié
// n'existent qu'en français pour l'instant — les liens pointent donc
// toujours vers les mêmes adresses /legal/... quelle que soit la
// langue, seuls les libellés changent. Un lecteur anglophone comprend
// où mène le lien, même si la page d'arrivée est encore en français.
export default function LegalFooter({ className = "", lang = "fr" }) {
  const t = STR[lang] || STR.fr;
  return (
    <footer
      className={`border-t py-6 text-center text-xs text-muted-foreground ${className}`}
    >
      <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 px-4">
        <Link
          to="/legal/mentions"
          className="hover:text-foreground hover:underline"
        >
          {t.mentions}
        </Link>
        <Link to="/legal/cgu" className="hover:text-foreground hover:underline">
          {t.cgu}
        </Link>
        <Link to="/legal/cgv" className="hover:text-foreground hover:underline">
          {t.cgv}
        </Link>
        <Link
          to="/legal/confidentialite"
          className="hover:text-foreground hover:underline"
        >
          {t.privacy}
        </Link>
        <Link
          to="/legal/cookies"
          className="hover:text-foreground hover:underline"
        >
          {t.cookies}
        </Link>
        <Link
          to="/legal/retractation"
          className="hover:text-foreground hover:underline"
        >
          {t.withdrawal}
        </Link>
        <Link
          to="/affiliate-program"
          className="font-semibold text-primary hover:underline"
        >
          {t.affiliate}
        </Link>
        <Link
          to="/legal/mentions#contact"
          className="hover:text-foreground hover:underline"
        >
          {t.contact}
        </Link>
      </div>
      <div className="mt-3">{t.copyright}</div>
    </footer>
  );
}
